import { z } from 'zod';
import { differenceInMinutes } from 'date-fns';
import { ReservationDateTimeForm } from '@lp/features/Scheduler/components/ReservationCell/types';
import { ReservationNode } from '@/api/apis/resources';

export const getDefaultReservationDateTimeValues = (data: ReservationNode): ReservationDateTimeForm => {
  const toDateString = data.to ?? new Date().toISOString();
  const totalMinutes = differenceInMinutes(toDateString, data.from);
  return {
    from: data.from,
    to: toDateString,
    duration: Math.floor(totalMinutes / 60),
    durationMinutes: totalMinutes % 60,
  };
};

export const reservationBarFormSchema = z.object({
  from: z.string().datetime({ offset: true }),
  to: z.string().datetime({ offset: true }),
  duration: z.number().int().min(0),
  durationMinutes: z.number().int().min(0).max(59),
});
